export const Utils = {
    FormatCurrency: (amount: number, currency: string): string => {
        let symbol = "";
        switch (currency) {
            case "ZAR":
                symbol = "R";
                break;
            case "EUR":
                symbol = "€";
                break;
            case "USD":
                symbol = "$";
                break;
            case "GBP":
                symbol = "£";
                break;
        }
        return `${symbol}${Number(amount).toFixed(2)}`;
    },
    GetAlias: (): string => {
        const paths = window.location.pathname.split('/');
        const reservedRoutes = ["products", "product", "admin", "orders", "order", "login", "register", "userprofile", "cart", "checkout", "ordersuccess", "", "d", "setup", "storeoperator", "instructions", "paymentproviders"];

        if (paths.length > 1 && reservedRoutes.indexOf(paths[1].toLowerCase()) === -1) {
            return paths[1].toLowerCase();
        }

        return "";
    },
    GetDomain: (): string => {
        const parts = window.location.hostname.split('.');
        return parts.length > 2 ? parts[parts.length - 3] : parts[0];
    },
    GetUrl: (link: string) => {
        var alias = Utils.GetAlias();
        return alias ? `/${alias}${link}` : link;
    },
    GetFullUrl: (link: string) => {
        return `${window.location.origin}${Utils.GetUrl(link)}`;
    },
    FormatPhoneNumber: (phoneCode: string, phoneNumber: string) => {
        return `${phoneCode}${phoneNumber.startsWith('0') ? phoneNumber.substring(1).replace(" ", "") : phoneNumber.replace(" ", "")}`;
    },
    CopyToClipboard: (text: string) => {
        navigator.clipboard.writeText(text).then(() => {
            console.log('Text copied to clipboard');
        }).catch(err => {
            console.error('Could not copy text: ', err);
        });
    },
    IsSameDay(date1: Date, date2: Date) {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
    },
    DifferenceInMinutes(date1: Date, date2: Date) {
        const diffMs = Math.abs(date1.getTime() - date2.getTime()); // difference in milliseconds
        return Math.floor(diffMs / 60000); // convert to minutes
    },
    FormatMinutesToHoursAndMinutes(totalMinutes: number) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${String(hours).padStart(2, "0")}h${String(minutes).padStart(2, "0")}m`;
    }
}
